import { Alert, Button, Card, Checkbox, Form, Input, Select } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import sspApi from 'src/component/app/ssp/SspApi'
import { uuidV4 } from 'src/util/Util'
import { CountryBean, SspBean } from '../../../api/api'
import { FormDataType, formDataLoader } from '../../../util/FormDataLoader'

const FormItem = Form.Item
const Option = Select.Option

const formInfoItems: FormDataType[] = [
    FormDataType.Countries,
]

const SspCreate = () => {

    const [info, setInfo] = useState({
        countries: [],
    })

    const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const navigateTo = useNavigate()

    const loadData = async () => {
        try {
            const resp = await formDataLoader(...formInfoItems)
            setInfo(resp as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadData()
    }, [])

    const handleSubmit = async () => {
        const values = await form.validateFields()
        try {
            await sspApi.create(values)
            navigateTo('/ssp')
        } catch (e) {
            setError(e.error)
        }
    }

    return <Form
        style={{
            maxWidth: '1000px', margin: '0 auto'
        }}
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 16 }}
    >
        {error && <Alert message={error} type="error" />}
        <Card title="SSP" size="small" className="form-card">
            <FormItem
                required
                name="name"
                label="Name"
            >
                <Input placeholder="Name" />
            </FormItem>
            <FormItem
                required
                name="endpoint"
                label="Endpoint"
            >
                <Input placeholder="Endpoint" />
            </FormItem>
            <FormItem
                required
                name="sspType"
                label="SSP Type"
            >
                <Select placeholder="Select SSP Type">
                    {Object.values(SspBean.SspTypeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                required
                name="billingType"
                label="Billing Type"
            >
                <Select placeholder="Select Billing Type">
                    {Object.values(SspBean.BillingTypeEnum).map(type => <Option key={type} value={type}>{type}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="apiKey"
                label="API key"
            >
                <Input placeholder="Generate API key" addonAfter={<Button size="small" type="text" onClick={() => form.setFieldValue('apiKey', uuidV4())}>Generate</Button>} />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue="true"
                required
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="consentValidation"
                label="TCF check"
                valuePropName="checked"
                required
            >
                <Checkbox />
            </FormItem>
        </Card>
        <div className="create-cancel-group">
            <Button type="primary" htmlType="submit">Create</Button>
            <Button htmlType="button" danger onClick={() => navigateTo('/ssp')}>Cancel</Button>
        </div>
    </Form>
}

export default SspCreate


// WEBPACK FOOTER //
// ./src/component/app/ssp/SspCreate.tsx